<template>
  <collapsible
    wrapper-classes="p-4"
    :label="labelToUpper(this.label)"
    :start-open="openFilter"
    :info="infoButton"
  >
    <template v-slot:content>
      <div v-if="isSearchable">
        <searchable-filter
          :facet-fields="sortedFacetField"
          :field-name="fieldName"
          :label="label"
          :selected-fields="selectedFields"
          @set-filters="setFilters"
        ></searchable-filter>
      </div>
      <div
        v-else
        class="p-4 xl:py-2 xl:px-2"
      >
        <check-box-filter
          :facet-fields="sortedFacetField"
          :field-name="fieldName"
          :label="label"
          :selected-fields="selectedFields"
          @set-filters="setFilters"
        ></check-box-filter>
      </div>
    </template>
  </collapsible>
</template>

<script>
import CheckBoxFilter from './CheckBoxFilter.vue';
import SearchableFilter from './SearchableFilter.vue';
import Collapsible from './Collapsible.vue';
export default {
  components: { Collapsible, CheckBoxFilter, SearchableFilter },
  props: {
    facetFields: {
      type: [Array, Object],
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    facetType: {
      type: String,
      default: 'facet',
    },
    label: {
      type: String,
      required: true,
    },
    selectedFields: {
      type: [Array, Object],
      required: false,
    },
    infoButton: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      filters: {
        'name': this.fieldName,
        'values': [],
      },
    }
  },
  computed: {
    isSearchable() {
      if (this.facetType === 'searchable') {
        return true;
      }
      return false;
    },
    openFilter() {
      return this.fieldName in this.selectedFields;
    },
    sortedFacetField() {
      return this.facetFields.sort(function(a, b) {
        const textA = a.key.toUpperCase();
        const textB = b.key.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
    }
  },
  methods: {
    labelToUpper(str) {
      var i, frags = str.split('_');
      for (i=0; i<frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    setFilters(e){
      this.filters = e;
      this.$emit('set-filters', this.filters);
    },
  },
}
</script>
